/**
 * Created by Daniela on 19/10/2016.
 */

export const newRoute: string = 'novo';
export const newRouteFemale: string = 'nova';
export const editRoute: string = 'editar';
export const detailRoute: string = 'detalhe';

export const configuracaoRoute: string = 'configuracoes';
export const configuracaoModuleName: any = {plural: 'Configurações', single: 'Configuração'};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/services/data.service.ts
 **/